import { render, staticRenderFns } from "./FormPasswordField.vue?vue&type=template&id=6b2b15c4"
import script from "./FormPasswordField.vue?vue&type=script&lang=ts"
export * from "./FormPasswordField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports